export default __webpack_public_path__ + "static/media/upDownArrow.7dd3da6e.svg";